module.exports = __webpack_public_path__ + "img/instruction-cocoa2-android-02.d53034c1.png";